import { ContractProposalBaseInvestmentToolType } from "Infrastructure/ApiZfp/Schema";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, object, string } from "yup";

export type ProposedSolutionWrapperFormType = {
  readonly formType: string;
  readonly partner?: string;
};

export const getProposedSolutionWrapperFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<ProposedSolutionWrapperFormType> = (t) => {
  return object({
    formType: string().required(t(Resources.Validation.Required)),
    partner: string().when("formType", (formType, schema) => {
      return [ContractProposalBaseInvestmentToolType.other, ContractProposalBaseInvestmentToolType.saving].includes(formType[0])
        ? schema
        : schema.required(t(Resources.Validation.Required));
    }),
  }).defined();
};
